import React from "react";
import { Box, Typography, Stack, Tooltip, IconButton } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { FolderIcon } from '@heroicons/react/24/outline';
import { Divider } from "@mui/material";
import DynamicBreadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { breakpoints } from "../../theme/theme";
import styles from "../../styles/pageHeader/index.module.scss";

const PageHeader = ({ projectName, title, description, actions, breadcrumbItems, subTitleComponent, titleChipComponent ,titleIcon }) => {
  const theme = useTheme();
  return (
    <Box>
      <Box className={`${styles.container}`}>
        <Box className={`${styles.breadcrumbsContainer}`}>
          <Box className={`${styles.breadcrumbsInnerContainer}`}>
            <Box className="icon-cover-small bg-blue600">
              <FolderIcon className="icon-small white" />
            </Box>
            {breadcrumbItems ? (
              <Box
                variant="breadcrumb"
                sx={{
                  color: theme.palette.customSidebar.blue600,
                  display: 'flex',
                  alignItems: 'center',
                  minHeight: 24,
                }}
              >
                <DynamicBreadcrumbs 
                  items={breadcrumbItems} 
                />
              </Box>
            ) : (
              <p className={styles.breadcrumbs}>
                {projectName}
              </p>
            )}
          </Box>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            {titleIcon && <>{titleIcon}</>}
            <Tooltip title={title} placement="top" arrow>
              <p className={`${styles.title} ${styles.titleContainer} ellipsis-container`}>
                {title}
              </p>
            </Tooltip>
            {titleChipComponent && <>{titleChipComponent}</>}
          </Stack>
          {subTitleComponent && <>{subTitleComponent}</>}
          {description && (
            <p className={`${styles.description} ${styles.descriptionContainer} ellipsis-container-line-2`}>
              {description}
            </p>
          )}
        </Box>
        {/* Right side: Actions */}
        {actions && (
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            flexShrink: 0, // Prevent actions from shrinking
            flexWrap: 'nowrap', // Prevent wrapping of action buttons
            minWidth: 'fit-content', // Ensure actions section doesn't shrink below button content
          }}>
            {actions}
          </Box>
        )}
      </Box>

      <Divider />
    </Box>
   

  );
};

export default PageHeader;
